<div class="ticket-actions-selector" [ngClass]="{ 'ticket-actions-selector__selected': isOpened }">
    <div
        class="ticket-actions-button"
        id="{{ menuButtonId }}"
        #menuButton
        *ngIf="actions.length > 1 || showDropdownAlways"
        [attr.aria-expanded]="isOpened || null"
        (click)="openClicked()"
        (keydown.enter)="openClicked()"
        (keydown.space)="openClicked()"
        (keydown.tab)="closeMenu()"
        role="button"
        tabindex="0"
        aria-haspopup="true"
        attr.aria-controls="{{ menuId }}">
        <span class="ticket-actions-selector__info-icon icon icon-actions"></span>
        <span class="ticket-actions-selector__info-link-text">
            <span>{{ 'TICKET_ACTIONS_DROPDOWN_TITLE' | translate }}</span>
            <span class="icon icon-arrow-dropdown"></span>
            <span class="icon icon-up-chevron"></span>
        </span>
    </div>

    <div class="ticket-actions-selector__content" [ngClass]="{ dropdown__display: isOpened }">
        <ul
            class="dropdown__actions"
            id="{{ menuId }}"
            #menuList
            [attr.aria-labelledby]="actions.length > 1 || showDropdownAlways ? menuButtonId : null"
            role="menu"
            tabindex="-1">
            <li *ngFor="let action of actions; index as i">
                <a
                    class="link"
                    #menuItem
                    (click)="click(action)"
                    (keydown)="onMenuItemKeyDown($event, action)"
                    role="menuitem"
                    tabindex="-1">
                    <span class="action-title">{{ action.title | translate }}</span>
                    <span class="action-description">{{ action.description | translate }}</span>
                </a>
            </li>
        </ul>
    </div>
</div>

<div
    class="single-ticket-left-content__items {{ actions[0].class }}-item"
    *ngIf="type === 'REGULAR' && actions.length === 1 && !showDropdownAlways">
    <span>
        <a
            class="link--no-line link dark:text-contrast-black"
            #actionLink
            (click)="click(actions[0])"
            (keydown.enter)="click(actions[0])"
            (keydown.space)="click(actions[0])"
            tabindex="0">
            <span *ngIf="actions[0].type === 'QR'">
                <mat-icon class="icon-qrcode">qr_code</mat-icon>
            </span>
            <span>{{ actions[0].title | translate }}</span>
        </a>
    </span>
</div>

<div
    class="wallet-ticket-left-content__items {{ actions[0].class }}-item align-right"
    *ngIf="type !== 'REGULAR' && actions.length === 1">
    <span *ngIf="actions[0].type === 'QR'">
        <img src="assets/icon_qrcode.png" alt="" />
    </span>
    <span>
        <a
            class="link--no-line link dark:text-contrast-black"
            (click)="click(actions[0])"
            (keydown.enter)="click(actions[0])"
            (keydown.space)="click(actions[0])"
            tabindex="0">
            {{ actions[0].title | translate }}
        </a>
    </span>
</div>
